import Highcharts from 'highcharts';

export const createDefaultExportingOptions = (
): Highcharts.ExportingOptions => ({
  enabled: false,
});
